/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { StartPaymentCloseTabData } from './StartPaymentCloseTabData';
import { StartPaymentRedirectData } from './StartPaymentRedirectData';
const StartPaymentAccessPlanDataParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('mode', [
    ['close_tab', StartPaymentCloseTabData],
    ['redirect', StartPaymentRedirectData],
]);
export const StartPaymentAccessPlanData = StartPaymentAccessPlanDataParser;
